import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { SelectedKpiService } from '@services';

@Component({
  selector: 'side-panel',
  templateUrl: './side-panel.component.html',
  styleUrls: ['./side-panel.component.scss']
})
export class SidePanelComponent {
  private selectedKpiService: SelectedKpiService = inject(SelectedKpiService);
  @Input() headerInfo?: { title: string };
  @Input() expanded = true;
  @Input() hasCustomHeader = false;
  @Output() expandedClicked = new EventEmitter<void>();

  closePanel(): void {
    this.selectedKpiService.setSelectedKpi(undefined);
  }

  expandedButtonClicked(): void {
    this.expandedClicked.emit();
  }
}
